import { createSelector } from '@reduxjs/toolkit';

import { camelcaseKeysFromApi } from '@vestigas/data';

import { type RootState } from '~/redux/store';

export const selectFilters = (state: RootState) => state.filters;

export const selectDeliveryFilterGroups = createSelector(
  [selectFilters],
  (filters) => ({
    filterGroupOpen: filters.delivery_filterGroupOpen,
    filterGroups: filters.delivery_filterGroups?.map((filterGroup) =>
      camelcaseKeysFromApi(filterGroup),
    ),
    filterRows: filters.delivery_filterRows,
    selectedFilterGroup: filters.delivery_selectedFilterGroup,
    selectedTab: filters.delivery_tab,
  }),
);
